export default {
  'quickNotes.title': '快捷备注',
  'quickNotes.column.display': '是否显示',
  'quickNotes.column.name': '名称',
  'quickNotes.column.foreign_name': '中文名',

  'quickNotes.create.title': '新建快捷备注',
  'quickNotes.edit.title': '编辑快捷备注',

  'quickNotes.name.required': '名称不能为空',
  'quickNotes.foreign_name.required': '中文名不能为空',

  'quickNotes.deletePromotion': '确认要删除此快捷备注吗？',
};
